import SimpleCrud from "./simple-crud/index.vue";
import NavMenu from "./nav-menu/index.vue";
import Step from "./step-wrapper/step.vue";
import StepWrapper from "./step-wrapper/step-wrapper.vue";
import TableLayout from "./TableLayout/index.vue";
import Table from "./Table/index.vue";
import Dialog from "./Dialog/index.vue";
import Drawer from "./Drawer/index.vue";
import LayoutTabs from "./LayoutTabs/index.vue";
import Pagination from "./Pagination/index.vue";
import SearchForm from "./SearchForm/index.vue";
import SearchControl from "./SearchLayoutForm/SearchControl.vue";
import SearchLayoutForm from "./SearchLayoutForm/index.vue";
import Form from "./Form/index.vue";
import Control from "./Form/Control.vue"
import Sidebar from "./Sidebar/index.vue";
import Navbar from "./Navbar/index.vue";
import Breadcrumb from "./Breadcrumb/index.vue";
import BreadcrumbLocal from "./BreadcrumbLocal/index.vue";
import SvgIcon from "./SvgIcon/index.vue";
// import SvgRaw from "./SvgRaw/index.vue";
import elementIcons from "./SvgIcon/svgicon";



export default {
  install(app, config) {
    // 注册组件
    app.component("SimpleCrud", SimpleCrud);
    app.component("NavMenu", NavMenu);
    app.component("Step", Step);
    app.component("StepWrapper", StepWrapper);
    app.component("Table", Table);
    app.component("TableLayout", TableLayout);
    app.component("Dialog", Dialog);
    app.component("Drawer", Drawer);
    app.component("LayoutTabs", LayoutTabs);
    app.component("Pagination", Pagination);
    app.component("SearchForm", SearchForm);
    app.component("SearchLayoutForm", SearchLayoutForm);
    app.component("SearchControl", SearchControl);
    app.component("Form", Form);
    app.component("Control", Control);
    app.component("Sidebar", Sidebar);
    app.component("Navbar", Navbar);
    app.component("Breadcrumb", Breadcrumb);
    app.component("BreadcrumbLocal", BreadcrumbLocal);
    //svg element icon
    app.use(elementIcons);
    app.component("svg-icon", SvgIcon);
    // app.component("svg-raw", SvgRaw);
  },
};
